<div   class="mb-27 mct-flex mct-row mct-justify-between mct-items-center">
  <span class="title-header">{{ 'banner-ads.title' | translate | titlecase }}</span>
  <div class="mct-flex mct-row mct-justify-between mct-items-end"  >
  <button pButton type="button" class="mct-flex atlas-btn atlas-btn-primary mr-10 mct-justify-end mct-items-stretch"  (click)="editDialog.open()">
    <i class="pi pi-plus"></i>
    {{ 'banner-ads.search.add-a-banner-ad' | translate | uppercase }}
  </button>
  <button pButton type="button" class="mct-flex atlas-btn atlas-btn-primary mct-justify-end mct-items-stretch"  (click)="openEmbedCodeDialog()">
    <i class="pi pi-plus"></i>
    {{ 'banner-ads.search.generate-banner-ad-embed-code' | translate | uppercase }}
  </button>
  </div>
</div>
<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'banner-ads.search.title' | translate | titlecase }}</div>
  <wl-banner-ad-search-params [(searchParams)]="searchParams"></wl-banner-ad-search-params>
  <div class="mt-32 mct-flex mct-row mct-justify-end mct-items-stretch"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>
<wl-banner-ad-search-grid #searchGrid [(searchParams)]="searchParams"></wl-banner-ad-search-grid>
<wl-banner-ad-edit-dialog #editDialog (bannerSaved)="searchGrid.search()"></wl-banner-ad-edit-dialog>
<wl-banner-ads-embed-code-dialog></wl-banner-ads-embed-code-dialog>
